import { useAuthContext } from '../../../contexts/authContext';
import { ModulesSideBar } from '../../components/navbar/components';
import { ILayout } from '../../../shared/types/layout';
import NavBar from '../../components/navbar/navbar';
import { Box } from '@mui/material';
import { Copyright } from '../../components/general/copyright/copyright';
import { useLocation } from 'react-router-dom';

const SIDEBAR_WIDTH = 60;
const NAVBAR_HEIGHT = 68;

export function LayoutDefault({ children }: ILayout) {
    const { tokenAuth } = useAuthContext();
    const location = useLocation();
    const hideTopBar = location?.pathname?.includes('licitaciones/');

    return (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            {tokenAuth && (
                <>
                    {!hideTopBar ? (
                        <Box
                            component="header"
                            sx={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: NAVBAR_HEIGHT,
                                zIndex: 1200,
                                bgcolor: 'background.paper',
                                borderBottom: 1,
                                borderColor: 'divider',
                            }}
                        >
                            <NavBar
                                modules={ModulesSideBar}
                                hideTopBar={hideTopBar}
                            />
                        </Box>
                    ) : (
                        <NavBar
                            modules={ModulesSideBar}
                            hideTopBar={hideTopBar}
                        />
                    )}
                </>
            )}

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    ml: tokenAuth && !hideTopBar ? `${SIDEBAR_WIDTH}px` : 0,
                    mt: tokenAuth ? (hideTopBar ? 0 : `${NAVBAR_HEIGHT}px`) : 0,
                    transition: (theme) =>
                        theme.transitions.create(['margin', 'width'], {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.leavingScreen,
                        }),
                    overflow: 'visible',
                    width: tokenAuth
                        ? `calc(100% - ${SIDEBAR_WIDTH}px)`
                        : '100%',
                    backgroundColor: 'background.default',
                }}
            >
                <Box
                    sx={{
                        flexGrow: 1,
                        minHeight: 0,
                        overflow: 'auto',
                        px: hideTopBar ? 0 : 3,
                        pt: hideTopBar ? 0 : 3,
                    }}
                >
                    {children}
                </Box>
                <Box sx={{ py: 2, textAlign: 'center' }}>
                    <Copyright className="copyrigth_sign_in" />
                </Box>
            </Box>
        </Box>
    );
}
